import React,{ useState,useEffect } from 'react';
import Data from './Data';

function Covid() {
    const [value, setvalue] = useState();
    const [country, setcountry] = useState('World');
    const [covidData, setcovidData] = useState({})
    const [loading, setloading] = useState(true);
    const [flag, setflag] = useState("")

    function toTitleCase(str) {
        return str.replace(
          /\w\S*/g,
          function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          }
        );
      }


    const fetchData = async()=>{
        try{ 
            const response = await fetch('https://coronavirus-19-api.herokuapp.com/countries');
            const data = await response.json();
            const countryData=data.filter((c)=>{
                return(country===c.country)
            })
            if (countryData){
                setcovidData(countryData);
                setloading(false)
            }

            const countrycodes = await fetch("https://gist.githubusercontent.com/DmytroLisitsyn/1c31186e5b66f1d6c52da6b5c70b12ad/raw/01b1af9b267471818f4f8367852bd4a2814cbae6/country_dial_info.json")
            const codes = await countrycodes.json();
            const flagCode = codes.filter((c)=>{
                return(c.name===country)
            })
            setflag(flagCode[0].code)
        }
        catch(error){
            console.log("The error is ",error);
        }
    }

    useEffect(() => {
        fetchData();
    }, [country])

    
    
    

    const submitValue=()=>{
        setcountry(toTitleCase(value));
        setcovidData({})
        setloading(true);
    }

    useEffect(() =>{fetchData()}, [])


    return (
        <>  
            <div className="container-fluid">
                <h1 className="text-center my-3">Covid-19 Tracker</h1>
                <div className="text-center">
                <input className="mb-3 w-25 p-2" placeholder="Search by country name" type="text" onChange={(e)=>setvalue(e.target.value)} />
                <button className="btn-dark text-light ms-2 p-2" style={{width:'80px'}} onClick={submitValue}>Search</button>
                </div>
                {loading?<h1 className="d-flex justify-content-center align-items-center mt-5">Loading....</h1>:Object.entries(covidData).length === 0?<h1 className="d-flex justify-content-center align-items-center mt-5">No Data Found!</h1>:<Data covidData={covidData} flag={flag}/>}
            </div>
            
        </>
    )
}

export default Covid
